import { ColumnName } from 'mapistry-shared';

export const isColumnName = (
  columnName: ColumnName | undefined,
): columnName is ColumnName => !!columnName;
